import * as Yup from 'yup'

export const verificationSchema = Yup.object().shape({
  verificationEmail: Yup.string()
    .email('Invalid email')
    .required('Email is required'),
})
export const insuranceSchema = Yup.object().shape({
  firstName: Yup.string().required('First Name is required'),
  lastName: Yup.string().required('Last Name is required'),
  dateOfBirth: Yup.string().required('Date of Birth is required'),
  gender: Yup.string().required('Gender is required'),
  memberId: Yup.string().nullable(),
  planNumber: Yup.string().nullable(),
  payerCode: Yup.string().nullable(),
  insurance_card_front: Yup.string().nullable(),
  insurance_card_back: Yup.string().nullable(),
  // Subscriber fields – all optional
  relationToPatient: Yup.string().nullable(),
  policyHolderFirstName: Yup.string().nullable(),
  policyHolderLastName: Yup.string().nullable(),
  policyHolderDateOfBirth: Yup.string().nullable(),
  policyHolderGender: Yup.string().nullable(),
})

export const processedInsuranceSchema = Yup.object().shape({
  firstName: Yup.string().required('First Name is required'),
  lastName: Yup.string().required('Last Name is required'),
  dateOfBirth: Yup.string().required('Date of Birth is required'),
  gender: Yup.string().required('Gender is required'),
  memberId: Yup.string().required('Member ID is required'),
  planNumber: Yup.string().nullable(),
  payerCode: Yup.string().required('Payer ID is required'),
  insurance_card_front: Yup.string().nullable(),
  insurance_card_back: Yup.string().nullable(),
  // Subscriber fields – conditionally required
  relationToPatient: Yup.string()
    .nullable()
    .test('subscriber-required', 'Relation to patient is required', function(
      value
    ) {
      const subscriberFields = [
        'policyHolderFirstName',
        'policyHolderLastName',
        'policyHolderDateOfBirth',
        'policyHolderGender',
        'policyHolderMemberId',
      ]
      const hasAnySubscriberInfo = subscriberFields.some(
        field => this.parent[field] && this.parent[field].trim() !== ''
      )
      return !hasAnySubscriberInfo || (value && value.trim() !== '')
    }),
  policyHolderFirstName: Yup.string()
    .nullable()
    .test(
      'subscriber-required',
      'Policy holder first name is required',
      function(value) {
        const subscriberFields = [
          'relationToPatient',
          'policyHolderLastName',
          'policyHolderDateOfBirth',
          'policyHolderGender',
          'policyHolderMemberId',
        ]
        const hasAnySubscriberInfo = subscriberFields.some(
          field => this.parent[field] && this.parent[field].trim() !== ''
        )
        return !hasAnySubscriberInfo || (value && value.trim() !== '')
      }
    ),
  policyHolderLastName: Yup.string()
    .nullable()
    .test(
      'subscriber-required',
      'Policy holder last name is required',
      function(value) {
        const subscriberFields = [
          'relationToPatient',
          'policyHolderFirstName',
          'policyHolderDateOfBirth',
          'policyHolderGender',
          'policyHolderMemberId',
        ]
        const hasAnySubscriberInfo = subscriberFields.some(
          field => this.parent[field] && this.parent[field].trim() !== ''
        )
        return !hasAnySubscriberInfo || (value && value.trim() !== '')
      }
    ),
  policyHolderDateOfBirth: Yup.string()
    .nullable()
    .test(
      'subscriber-required',
      'Policy holder date of birth is required',
      function(value) {
        const subscriberFields = [
          'relationToPatient',
          'policyHolderFirstName',
          'policyHolderLastName',
          'policyHolderGender',
          'policyHolderMemberId',
        ]
        const hasAnySubscriberInfo = subscriberFields.some(
          field => this.parent[field] && this.parent[field].trim() !== ''
        )
        return !hasAnySubscriberInfo || (value && value.trim() !== '')
      }
    ),
  policyHolderGender: Yup.string()
    .nullable()
    .test('subscriber-required', 'Policy holder gender is required', function(
      value
    ) {
      const subscriberFields = [
        'relationToPatient',
        'policyHolderFirstName',
        'policyHolderLastName',
        'policyHolderDateOfBirth',
        'policyHolderMemberId',
      ]
      const hasAnySubscriberInfo = subscriberFields.some(
        field => this.parent[field] && this.parent[field].trim() !== ''
      )
      return !hasAnySubscriberInfo || (value && value.trim() !== '')
    }),
  policyHolderMemberId: Yup.string()
    .nullable()
    .test(
      'subscriber-required',
      'Policy holder member id is required',
      function(value) {
        const subscriberFields = [
          'relationToPatient',
          'policyHolderFirstName',
          'policyHolderLastName',
          'policyHolderDateOfBirth',
        ]
        const hasAnySubscriberInfo = subscriberFields.some(
          field => this.parent[field] && this.parent[field].trim() !== ''
        )
        return !hasAnySubscriberInfo || (value && value.trim() !== '')
      }
    ),
})
